import { render, staticRenderFns } from "./TypeImage.vue?vue&type=template&id=b57d91da&"
import script from "./TypeImage.vue?vue&type=script&lang=js&"
export * from "./TypeImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports